<template>
  <v-container style="margin-top: 20px;">
    <v-container class="toolbar__container" style="margin-bottom: 0;">
      <v-row align="center">
        <v-col cols="12" sm="auto">
          <div class="text-caption grey--text text--darken-1">{{ $t('relExternalAddressKpis.filters.origin') }}</div>
          <v-btn-toggle :value="origem" mandatory dense rounded color="primary" @change="trocarOrigem">
            <v-btn small :value="ORIGEM_ENDERECOS_EXTERNOS">{{ $t('relExternalAddressKpis.filters.externalAddresses') }}</v-btn>
            <v-btn small :value="ORIGEM_PRE_CANDIDATOS">{{ $t('relExternalAddressKpis.filters.preCandidates') }}</v-btn>
            <v-btn small :value="ORIGEM_CANDIDATOS">{{ $t('relExternalAddressKpis.filters.candidates') }}</v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="12" sm="8" md="5">
          <v-autocomplete
            v-model="agenciaSelected"
            :items="agenciasFiltro"
            :item-text="agenciaLabel"
            item-value="id_agencia_emprego"
            :label="$t('externalAddress.filters.agency')"
            clearable
            @change="carregar"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-autocomplete
            :value="estadoSelected === '' ? SEM_ESTADO : estadoSelected"
            :items="estadosFiltro"
            item-text="texto"
            item-value="estado"
            :label="$t('relExternalAddressKpis.filters.state')"
            :disabled="!estados.length"
            clearable
            @change="filtrarEstado"
          />
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small fab color="primary darken-1" class="white--text" :loading="loadingMapa || loadingKpis || loadingtable"
                v-bind="attrs" v-on="on" @click="atualizar">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('relExternalAddressKpis.refresh') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <KpisEnderecosExternosCards :kpis="kpis" :loading="loadingKpis" :turnos="turnos" />
      <v-row v-if="resumoEstado" dense>
        <v-col cols="12" class="py-0 text-caption grey--text text--darken-1">
          <v-icon x-small class="mr-1">mdi-map-marker-outline</v-icon>
          {{ $t('relExternalAddressKpis.filters.stateSummary', {
            state: resumoEstado.estado || $t('relExternalAddressKpis.map.noState'),
            total: numero(resumoEstado.total), validated: numero(resumoEstado.validados),
            valid: numero(resumoEstado.validos), rejected: numero(resumoEstado.rejeitados),
            pct: pct(resumoEstado.pct_validos_dos_validados) }) }}
        </v-col>
      </v-row>
    </v-container>

    <v-card ref="cardMapa" outlined class="mt-4 mapa-card">
      <v-card-text>
        <div class="text-overline primary--text">{{ $t('relExternalAddressKpis.map.overline') }}</div>
        <div class="text-h6">{{ $t('relExternalAddressKpis.map.title') }}</div>
        <div class="text-body-2 grey--text text--darken-1 mb-3">{{ $t('relExternalAddressKpis.map.description') }}</div>

        <div class="d-flex flex-wrap align-center mb-3" style="gap: 8px;">
          <v-btn-toggle v-model="camadas" multiple dense rounded color="primary">
            <v-btn small value="pontos">{{ $t('relExternalAddressKpis.map.points') }}</v-btn>
            <v-btn small value="calor">{{ $t('relExternalAddressKpis.map.heatmap') }}</v-btn>
          </v-btn-toggle>
          <v-divider vertical class="mx-1" />
          <v-btn small outlined rounded :disabled="!mapaPronto" @click="zoom(1)">
            <v-icon small>mdi-plus</v-icon>
          </v-btn>
          <v-btn small outlined rounded :disabled="!mapaPronto" @click="zoom(-1)">
            <v-icon small>mdi-minus</v-icon>
          </v-btn>
          <v-btn small outlined rounded :disabled="!celulasVisiveis.length" @click="enquadrar">
            {{ $t('relExternalAddressKpis.map.fitAll') }}
          </v-btn>
        </div>

        <v-row>
          <v-col cols="12" md="9">
            <div class="mapa-wrapper">
              <l-map
                ref="mapa"
                :zoom="4"
                :center="centroInicial"
                :options="{ zoomControl: false, preferCanvas: true }"
                style="height: 100%; width: 100%;"
                @ready="onMapaPronto"
                @click="onMapaClick"
              >
                <l-tile-layer :url="url" :attribution="attribution" />
              </l-map>
              <!-- Filtros ativos do mapa, flutuando no canto inferior esquerdo. -->
              <v-card
                v-if="estadoSelected !== null || motivoSelecionado"
                class="mapa-filtros pa-2"
                elevation="4"
              >
                <div class="d-flex align-center mb-1">
                  <v-icon x-small color="primary" class="mr-1">mdi-filter-variant</v-icon>
                  <span class="text-overline primary--text mapa-filtros-titulo">{{ $t('relExternalAddressKpis.map.activeFilters') }}</span>
                  <v-spacer />
                  <v-btn x-small text color="primary" class="ml-2" @click="limparFiltrosMapa">
                    {{ $t('relExternalAddressKpis.map.clearFilters') }}
                  </v-btn>
                </div>
                <div class="d-flex flex-column align-start" style="gap: 4px;">
                  <v-chip v-if="estadoSelected !== null" small close color="primary" outlined @click:close="selecionarEstado(estadoSelected)">
                    <v-icon x-small left>mdi-map-marker-outline</v-icon>
                    {{ estadoSelected || $t('relExternalAddressKpis.map.noState') }}
                  </v-chip>
                  <v-chip
                    v-if="motivoSelecionado"
                    small
                    close
                    outlined
                    class="chip-motivo"
                    :color="motivoSelecionado.validado ? cores.valido : cores.rejeitado"
                    @click:close="selecionarMotivo(motivoSelecionado.chave)"
                  >
                    <v-icon x-small left>{{ motivoSelecionado.validado ? 'mdi-check' : 'mdi-close' }}</v-icon>
                    <span class="text-truncate">{{ motivoSelecionado.texto }}</span>
                  </v-chip>
                </div>
              </v-card>
              <v-overlay absolute :value="loadingMapa" :opacity="0.15">
                <v-progress-circular indeterminate color="primary" />
              </v-overlay>
              <div v-if="!loadingMapa && kpis && !kpis.calculado" class="mapa-vazio text-body-2">
                {{ $t('externalAddress.kpis.notCalculated') }}
              </div>
              <div v-else-if="!loadingMapa && mapaCarregado && !celulas.length" class="mapa-vazio text-body-2">
                {{ $t('relExternalAddressKpis.map.empty') }}
              </div>
            </div>
          </v-col>

          <v-col cols="12" md="3">
            <div class="text-overline primary--text">{{ $t('relExternalAddressKpis.map.points') }}</div>
            <div class="d-flex align-center mb-1">
              <span class="legenda-circulo mr-2" :style="{ background: cores.valido }" />
              {{ $t('relExternalAddressKpis.map.validated') }}
            </div>
            <div class="d-flex align-center mb-3">
              <span class="legenda-losango mr-2" :style="{ background: cores.rejeitado }" />
              {{ $t('relExternalAddressKpis.map.rejected') }}
            </div>

            <div class="text-overline primary--text">{{ $t('relExternalAddressKpis.map.validationRate') }}</div>
            <div class="legenda-gradiente" :style="{ background: gradienteTaxa }" />
            <div class="d-flex justify-space-between text-caption grey--text text--darken-1">
              <span>0%</span><span>50%</span><span>100%</span>
            </div>
            <div class="text-caption grey--text text--darken-1 mb-3">{{ $t('relExternalAddressKpis.map.intensityHint') }}</div>

            <div class="text-overline primary--text">{{ $t('relExternalAddressKpis.map.byState') }}</div>
            <div class="estados-lista">
              <v-tooltip v-for="e in estadosLista" :key="'estado-' + e.estado" left>
                <template v-slot:activator="{ on }">
                  <div
                    class="estado-linha"
                    :class="{ 'estado-linha--ativa': estadoSelected === e.estado }"
                    v-on="on"
                    @click="selecionarEstado(e.estado)"
                  >
                    <span class="estado-sigla">{{ e.estado || '—' }}</span>
                    <div class="estado-barra">
                      <div :style="{ width: larguraBarra(e.validos, e.validados), background: cores.valido }" />
                      <div :style="{ width: larguraBarra(e.rejeitados, e.validados), background: cores.rejeitado }" />
                    </div>
                    <span class="estado-total">{{ numero(e.total) }}</span>
                  </div>
                </template>
                <div>{{ $t('relExternalAddressKpis.map.stateTooltip', {
                  total: numero(e.total), validated: numero(e.validados), valid: numero(e.validos),
                  rejected: numero(e.rejeitados), pct: pct(e.pct_validos_dos_validados) }) }}</div>
              </v-tooltip>
              <div v-if="!estadosLista.length && !loadingMapa" class="text-caption grey--text">
                {{ $t('relExternalAddressKpis.map.empty') }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card outlined class="mt-4 mapa-card">
      <v-card-text>
        <div class="text-overline primary--text">{{ $t('relExternalAddressKpis.reasons.overline') }}</div>
        <div class="text-h6 mb-3">
          {{ $t('relExternalAddressKpis.reasons.title') }}
          <v-chip v-if="estadoSelected !== null" small outlined color="primary" class="ml-2">
            {{ estadoSelected || $t('relExternalAddressKpis.map.noState') }}
          </v-chip>
        </div>
        <v-skeleton-loader v-if="loadingKpis && !kpis" type="list-item@4" />
        <div v-else-if="!motivos.length" class="text-body-2 grey--text">
          {{ $t('relExternalAddressKpis.reasons.empty') }}
        </div>
        <div class="text-caption grey--text text--darken-1 mb-2">{{ $t('relExternalAddressKpis.reasons.clickHint') }}</div>
        <div
          v-for="m in motivos"
          :key="m.chave"
          class="motivo-linha mb-1"
          :class="{ 'motivo-linha--ativa': motivoSelected === m.chave }"
          role="button"
          tabindex="0"
          @click="selecionarMotivo(m.chave)"
          @keydown.enter="selecionarMotivo(m.chave)"
        >
          <div class="d-flex align-center flex-wrap" style="gap: 8px;">
            <v-chip x-small label outlined :color="m.validado ? cores.valido : cores.rejeitado">
              <v-icon x-small left>{{ m.validado ? 'mdi-check' : 'mdi-close' }}</v-icon>
              {{ m.validado ? $t('relExternalAddressKpis.map.validated') : $t('relExternalAddressKpis.map.rejected') }}
            </v-chip>
            <span class="text-body-2 motivo-texto">{{ m.texto }}</span>
            <v-spacer />
            <span class="motivo-total font-weight-bold">{{ numero(m.total) }}</span>
            <span class="motivo-pct text-caption grey--text text--darken-1">{{ pct(m.pct) }}</span>
          </div>
          <v-progress-linear
            class="mt-1"
            rounded
            height="8"
            :value="m.largura"
            :color="m.validado ? cores.valido : cores.rejeitado"
            background-color="grey"
            background-opacity="0.2"
          />
        </div>
        <div v-if="motivos.some((m) => !m.registrado)" class="text-caption grey--text text--darken-1">
          {{ $t('relExternalAddressKpis.reasons.notRecordedHint') }}
        </div>
      </v-card-text>
    </v-card>

    <v-card outlined class="mt-4 mapa-card">
      <v-card-text>
        <div class="text-overline primary--text">{{ $t('relExternalAddressKpis.evaluation.overline') }}</div>
        <div class="text-h6">
          {{ $t('relExternalAddressKpis.evaluation.title') }}
          <v-chip v-if="estadoSelected !== null" small outlined color="primary" class="ml-2">
            {{ estadoSelected || $t('relExternalAddressKpis.map.noState') }}
          </v-chip>
        </div>
        <div class="text-body-2 grey--text text--darken-1 mb-2">{{ $t('relExternalAddressKpis.evaluation.description') }}</div>
        <div class="d-flex flex-wrap text-caption mb-3" style="gap: 16px;">
          <span v-for="s in seriesAvaliacao" :key="'leg-' + s.chave" class="d-flex align-center">
            <span class="legenda-quadrado mr-1" :style="{ background: s.cor }" />{{ s.nome }}
          </span>
        </div>
        <v-skeleton-loader v-if="loadingKpis && !kpis" type="image" />
        <div v-else-if="!temAvaliacao" class="text-body-2 grey--text">
          {{ $t('relExternalAddressKpis.evaluation.empty') }}
        </div>
        <v-row v-else dense>
          <v-col v-for="g in graficosAvaliacao" :key="'aval-' + g.metrica" cols="12" md="4">
            <v-card outlined class="mapa-card">
              <v-card-text class="pb-0">
                <div class="d-flex align-baseline flex-wrap">
                  <span class="text-subtitle-1 font-weight-medium">{{ g.titulo }}</span>
                  <v-spacer />
                  <span class="text-caption grey--text text--darken-1 motivo-total">{{ g.resumo }}</span>
                </div>
              </v-card-text>
              <apexchart type="bar" height="220" :options="g.options" :series="g.series" />
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card outlined class="mt-4 mapa-card">
      <v-card-text>
        <div class="text-overline primary--text">{{ $t('relExternalAddressKpis.addresses.overline') }}</div>
        <div class="text-h6">
          {{ $t('relExternalAddressKpis.addresses.title') }}
          <v-chip v-if="estadoSelected !== null" small outlined color="primary" class="ml-2">
            {{ estadoSelected || $t('relExternalAddressKpis.map.noState') }}
          </v-chip>
          <v-chip
            v-if="motivoSelecionado"
            small
            outlined
            class="ml-2 chip-motivo"
            :color="motivoSelecionado.validado ? cores.valido : cores.rejeitado"
          >
            <v-icon x-small left>{{ motivoSelecionado.validado ? 'mdi-check' : 'mdi-close' }}</v-icon>
            <span class="text-truncate">{{ motivoSelecionado.texto }}</span>
          </v-chip>
        </div>
        <div class="text-body-2 grey--text text--darken-1 mb-3">{{ $t('relExternalAddressKpis.addresses.description') }}</div>
        <div class="d-flex flex-wrap align-center mb-3" style="gap: 8px;">
          <v-chip small outlined :color="totalSelecionados ? 'primary' : undefined">
            {{ $t('relExternalAddressKpis.selection.count', { count: numero(totalSelecionados), max: numero(LIMITE_SELECAO) }) }}
          </v-chip>
          <v-btn small text color="primary" :disabled="!totalSelecionados" @click="limparSelecao">
            {{ $t('relExternalAddressKpis.selection.clear') }}
          </v-btn>
          <v-spacer />
          <v-btn small color="primary" :disabled="!totalSelecionados" @click="irParaRevalidacao">
            <v-icon small left>mdi-check-all</v-icon>
            {{ $t('relExternalAddressKpis.selection.revalidate') }}
          </v-btn>
        </div>
        <merus-data-table
          :headers="headersEnderecos"
          :items="enderecos"
          :value="itensSelecionadosPagina"
          show-select
          @input="onSelecao"
          :loading="loadingtable"
          :loading-text="$t('system.messages.loading')"
          item-key="chave"
          :server-items-length="totalEnderecos"
          :items-per-page="numberOfRows"
          :items-per-page-last-option="itemsPerPageLastOption"
          :server-sort-by="serverSortBy"
          :server-sort-desc="serverSortDesc"
          dense
          @update:options="onTableOptions"
          @update:filters="onFiltersUpdate"
          style="border-radius: 10px;">
          <template v-slot:toolbar>
            <CadastroToolbar
              :title="$t('relExternalAddressKpis.addresses.title')"
              :token="token || ''"
              :items="enderecos"
              :load-items-for-export="loadItemsForExport"
              :csv-title="$t('relExternalAddressKpis.addresses.title')"
              :csv-headers="headersEnderecos"
              :pdf-title="$t('relExternalAddressKpis.addresses.title')"
              :pdf-headers="headersEnderecos"
              :pdf-filename="$t('relExternalAddressKpis.addresses.pdfFilename')"
              hide-search />
          </template>
          <template v-slot:item.resultado_texto="{ item }">
            <v-chip x-small label outlined :color="corResultado(item.resultado)">
              {{ item.resultado_texto }}
            </v-chip>
          </template>
          <template v-slot:item.cercas="{ item }">
            <span class="motivo-total">{{ item.cercas == null ? '—' : numero(item.cercas) }}</span>
          </template>
          <template v-slot:item.linhas="{ item }">
            <span class="motivo-total">{{ item.linhas == null ? '—' : numero(item.linhas) }}</span>
          </template>
          <template v-slot:item.locations="{ item }">
            <span class="motivo-total">{{ item.locations == null ? '—' : numero(item.locations) }}</span>
          </template>
        </merus-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import L from "leaflet";
import { LMap, LTileLayer } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import { COR_VALIDACAO, formatPct } from "@/utils/kpisEnderecosExternos";
import { salvarSelecaoRevalidacao } from "@/utils/revalidacaoSelecao";
import KpisEnderecosExternosCards from "./Enderecos/KpisEnderecosExternosCards.vue";
import MerusDataTable from "./Tables/MerusDataTable.vue";
import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
import serverTableMixin from "@/mixins/serverTableMixin";
import { buildRequestParams, computePageState, fetchAllServerPagesForExport } from "@/utils/serverTablePagination";
import { CamadaCalorTaxaValidacao, CamadaPontosValidacao } from "./mapas/camadaTaxaValidacao";

/** Sem agência vinculada: mesmo sentinela da aba Endereços Externos (-1 = IS NULL). */
const AGENCIA_SEM_VINCULO = -1;
/** Raio, em pixels, do clique que abre o resumo de uma célula. */
const RAIO_CLIQUE = 8;
/** Métricas dos histogramas de avaliação (chaves de `avaliacao` em getkpisenderecosexternos). */
const METRICAS_AVALIACAO = ['cercas', 'linhas', 'locations'];
/** Código da pendência gravado na validação -> chave em addressValidation.* (como em cercasETurnos.js). */
const AJUSTES_VALIDACAO = {
  needsShiftAdjustment: 'adjustmentNeedsShift',
  noVacancy: 'adjustmentNoVacancy',
  newStop: 'adjustmentNewStop',
};
/** Origem dos snapshots (parâmetro `origem` dos endpoints): endereços externos, candidatos ou pré-candidatos. */
const ORIGEM_ENDERECOS_EXTERNOS = 'E';
const ORIGEM_CANDIDATOS = 'C';
const ORIGEM_PRE_CANDIDATOS = 'P';
/** Máximo de registros levados de uma vez para a revalidação no CRUD de Candidatos. */
const LIMITE_SELECAO = 500;
/** Valor do select para endereços sem estado: '' seria tratado como vazio pelo v-autocomplete. */
const SEM_ESTADO = '__sem_estado__';
/** Colunas exibidas como texto na tabela por endereço -> coluna ordenável do endpoint. */
const ORDENACAO_ENDERECOS = { estado_texto: 'estado', unidade: 'cod_unidade', resultado_texto: 'resultado' };

/**
 * Relatório "KPIs de validação de endereços externos": os KPIs da aba Endereços Externos do
 * CRUD de Candidatos e um mapa com a taxa de validação por região (pontos e mapa de calor) e
 * por estado, de endereços externos, candidatos ou pré-candidatos (seletor da barra). Tudo vem dos snapshots da rotina CALCULA KPIS ENDERECOS EXTERNOS do monitor.
 */
export default {
  name: "RELKpisEnderecosExternos",
  components: { LMap, LTileLayer, KpisEnderecosExternosCards, MerusDataTable, CadastroToolbar },
  mixins: [serverTableMixin],
  data: () => ({
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    centroInicial: [-14.2, -51.9],
    agencias: [],
    turnos: [],
    agenciaSelected: null,
    origem: ORIGEM_ENDERECOS_EXTERNOS,
    kpis: null,
    loadingKpis: false,
    celulas: [],
    estados: [],
    loadingMapa: false,
    mapaCarregado: false,
    /** null = todos os estados; '' = endereços sem estado. */
    estadoSelected: null,
    /** Chave (motivo|ajustes|validado) do resultado clicado; null = todos os motivos. */
    motivoSelected: null,
    /** Motivos das células do mapa (o índice vem em cada ponto de getmapakpisenderecosexternos). */
    motivosMapa: [],
    camadas: ["pontos", "calor"],
    mapaPronto: false,
    /** Só a resposta da última requisição vale; as anteriores são descartadas. */
    reqSeq: 0,
    // Tabela por endereço (paginada no servidor, como as do CRUD de Candidatos).
    token: null,
    enderecos: [],
    loadingtable: false,
    totalEnderecos: 0,
    pageNumber: 1,
    numberOfRows: 10,
    itemsPerPageLastOption: 1000,
    lastItemsPerPageBeforeTodos: 10,
    serverSortBy: [],
    serverSortDesc: [],
    searchFilters: {},
    tabelaSeq: 0,
    /** Registros marcados na tabela, de todas as páginas: chave da linha -> id do registro no CRUD. */
    selecao: {},
    LIMITE_SELECAO,
    SEM_ESTADO,
    ORIGEM_ENDERECOS_EXTERNOS,
    ORIGEM_CANDIDATOS,
    ORIGEM_PRE_CANDIDATOS,
  }),
  computed: {
    agenciasFiltro() {
      return [
        { id_agencia_emprego: AGENCIA_SEM_VINCULO, cod_agencia: null, nome: this.$t('externalAddress.filters.noAgency') },
        ...(this.agencias || []),
      ];
    },
    params() {
      const ag = this.agenciaSelected;
      const params = { origem: this.origem };
      if (ag != null && ag !== '') params.id_agencia_emprego = ag;
      return params;
    },
    cores() {
      return { valido: COR_VALIDACAO[1], rejeitado: COR_VALIDACAO[4], neutro: COR_VALIDACAO.none };
    },
    gradienteTaxa() {
      return `linear-gradient(to right, ${this.cores.rejeitado}, ${this.cores.neutro}, ${this.cores.valido})`;
    },
    /** Estados do mapa da agência, na ordem por total; '' (sem estado) vira um rótulo. */
    estadosFiltro() {
      return this.estados.map((e) => ({
        estado: e.estado === '' ? SEM_ESTADO : e.estado,
        texto: e.estado || this.$t('relExternalAddressKpis.map.noState'),
      }));
    },
    resumoEstado() {
      if (this.estadoSelected === null) return null;
      return this.estados.find((e) => e.estado === this.estadoSelected) || null;
    },
    /** Séries dos histogramas, de baixo para cima na pilha: validado, rejeitado, com erro. */
    seriesAvaliacao() {
      return [
        { chave: 'validados', nome: this.$t('relExternalAddressKpis.map.validated'), cor: this.cores.valido },
        { chave: 'rejeitados', nome: this.$t('relExternalAddressKpis.map.rejected'), cor: this.cores.rejeitado },
        { chave: 'com_erro', nome: this.$t('relExternalAddressKpis.evaluation.withError'), cor: this.cores.neutro },
      ];
    },
    /** Avaliação do estado escolhido (ou de todos), como o mapa. */
    avaliacaoAtual() {
      const a = (this.kpis && this.kpis.avaliacao) || {};
      if (this.estadoSelected === null) return a.geral || {};
      return (a.por_estado && a.por_estado[this.estadoSelected]) || {};
    },
    temAvaliacao() {
      const a = this.avaliacaoAtual;
      return METRICAS_AVALIACAO.some((m) => a[m] && a[m].total > 0);
    },
    /** Um gráfico por métrica, todos na mesma escala para comparar as três. */
    graficosAvaliacao() {
      const a = this.avaliacaoAtual;
      const escuro = !!this.$vuetify.theme.dark;
      const superficie = escuro ? '#1E1E1E' : '#FFFFFF';
      const maior = METRICAS_AVALIACAO.reduce((m, metrica) => {
        const faixas = (a[metrica] && a[metrica].faixas) || [];
        return Math.max(m, ...faixas.map((f) => f.validados + f.rejeitados + f.com_erro), 0);
      }, 0);
      const fmt = (v) => this.numero(v);
      const dec = (v) => (v == null ? '-' : Number(v).toLocaleString(this.$i18n && this.$i18n.locale, { maximumFractionDigits: 1 }));
      return METRICAS_AVALIACAO.map((metrica) => {
        const m = a[metrica] || { faixas: [] };
        return {
          metrica,
          titulo: this.$t(`relExternalAddressKpis.evaluation.${metrica}`),
          resumo: this.$t('relExternalAddressKpis.evaluation.summary', {
            mean: dec(m.media), median: dec(m.mediana), max: dec(m.maximo) }),
          series: this.seriesAvaliacao.map((s) => ({ name: s.nome, data: m.faixas.map((f) => f[s.chave]) })),
          options: {
            chart: { stacked: true, toolbar: { show: false }, background: 'transparent', animations: { enabled: false } },
            theme: { mode: escuro ? 'dark' : 'light' },
            colors: this.seriesAvaliacao.map((s) => s.cor),
            plotOptions: { bar: { columnWidth: '70%', borderRadius: 4, borderRadiusApplication: 'end', borderRadiusWhenStacked: 'last' } },
            // Contorno da cor da superfície: separa os segmentos da pilha (vermelho e verde se confundem em daltonismo).
            stroke: { show: true, width: 2, colors: [superficie] },
            dataLabels: { enabled: false },
            legend: { show: false },
            grid: { borderColor: escuro ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.08)', strokeDashArray: 0, padding: { left: 4, right: 4 } },
            xaxis: {
              categories: m.faixas.map((f) => f.rotulo),
              axisBorder: { show: false },
              axisTicks: { show: false },
              labels: { style: { fontSize: '10px' } },
              tooltip: { enabled: false },
            },
            yaxis: { min: 0, max: maior || 1, tickAmount: 2, forceNiceScale: true, labels: { formatter: fmt, style: { fontSize: '10px' } } },
            tooltip: {
              shared: true,
              intersect: false,
              theme: escuro ? 'dark' : 'light',
              x: { formatter: (v) => `${this.$t(`relExternalAddressKpis.evaluation.${metrica}`)}: ${v}` },
              y: { formatter: fmt },
            },
            states: { hover: { filter: { type: 'darken', value: 0.9 } } },
          },
        };
      });
    },
    headersEnderecos() {
      // Sem cod-tabela: `sortable`/`filtrable` precisam vir explícitos. O endpoint só filtra
      // pelo identificador; o resto segue os filtros do relatório (agência, estado, motivo).
      const col = (text, value, filtrable = false) => ({ text, value, sortable: true, filtrable, show: true });
      return [
        col(this.$t(`relExternalAddressKpis.addresses.identifier${this.origem}`), 'identificador', true),
        col(this.$t('relExternalAddressKpis.addresses.agency'), 'agencia_emprego'),
        col(this.$t('relExternalAddressKpis.addresses.state'), 'estado_texto'),
        col(this.$t('relExternalAddressKpis.addresses.bestLine'), 'melhor_linha'),
        col(this.$t('relExternalAddressKpis.addresses.unit'), 'unidade'),
        col(this.$t('relExternalAddressKpis.addresses.fences'), 'cercas'),
        col(this.$t('relExternalAddressKpis.addresses.lines'), 'linhas'),
        col(this.$t('relExternalAddressKpis.addresses.locations'), 'locations'),
        col(this.$t('relExternalAddressKpis.addresses.result'), 'resultado_texto'),
      ];
    },
    /** Filtros do relatório aplicados à tabela: origem, agência, estado e o motivo clicado. */
    paramsEnderecos() {
      const params = { ...this.params };
      if (this.estadoSelected !== null) params.estado = this.estadoSelected;
      const m = this.motivoSelecionado;
      if (m) {
        params.motivo = m.motivo || '';
        params.ajustes = (m.ajustes || []).join(',');
        params.validado = m.validado ? 1 : 0;
      }
      return params;
    },
    totalSelecionados() {
      return Object.keys(this.selecao).length;
    },
    /** Linhas da página atual que estão marcadas (o que o v-data-table precisa para mostrar o check). */
    itensSelecionadosPagina() {
      return this.enderecos.filter((e) => e.chave in this.selecao);
    },
    /** Resultado por motivo (getkpisenderecosexternos), com o texto traduzido e a barra relativa ao maior. */
    motivos() {
      // Do estado escolhido (ou de todos), como o mapa.
      const m = (this.kpis && this.kpis.motivos) || {};
      const doFiltro = this.estadoSelected === null ? m.geral : (m.por_estado || {})[this.estadoSelected];
      const lista = Array.isArray(doFiltro) ? doFiltro : [];
      const maior = lista.reduce((m, r) => Math.max(m, Number(r.total) || 0), 0);
      return lista.map((r) => ({
        ...r,
        chave: `${r.motivo}|${(r.ajustes || []).join(',')}|${r.validado ? 1 : 0}`,
        registrado: !!r.motivo,
        texto: this.textoMotivo(r),
        largura: maior ? ((Number(r.total) || 0) / maior) * 100 : 0,
      }));
    },
    /**
     * Sem motivo escolhido, as células de mesma posição (separadas por motivo na API) voltam a
     * ser uma só, com a posição média ponderada; com motivo, só as células dele.
     */
    celulasDoMotivo() {
      if (this.motivoSelected) return this.celulas.filter((c) => c.motivoChave === this.motivoSelected);
      const porPosicao = new Map();
      for (const c of this.celulas) {
        const k = `${c.estado}|${Math.round(c.lat * 1000)}|${Math.round(c.lng * 1000)}`;
        const a = porPosicao.get(k);
        if (!a) {
          porPosicao.set(k, { ...c, sLat: c.lat * c.total, sLng: c.lng * c.total });
          continue;
        }
        a.sLat += c.lat * c.total;
        a.sLng += c.lng * c.total;
        a.total += c.total;
        a.validados += c.validados;
        a.validos += c.validos;
      }
      return Object.freeze(Array.from(porPosicao.values()).map((a) => ({
        estado: a.estado,
        lat: a.total ? a.sLat / a.total : a.lat,
        lng: a.total ? a.sLng / a.total : a.lng,
        total: a.total,
        validados: a.validados,
        validos: a.validos,
      })));
    },
    celulasVisiveis() {
      if (this.estadoSelected === null) return this.celulasDoMotivo;
      return this.celulasDoMotivo.filter((c) => c.estado === this.estadoSelected);
    },
    /** O resultado clicado, com o texto traduzido (para o chip do mapa). */
    motivoSelecionado() {
      if (!this.motivoSelected) return null;
      const m = this.motivosMapa.find((x) => x.chave === this.motivoSelected);
      return m ? { ...m, texto: this.textoMotivo(m) } : null;
    },
    /** Lista "Por estado": com motivo escolhido, conta só os endereços dele. */
    estadosLista() {
      if (!this.motivoSelected) return this.estados;
      const porEstado = new Map();
      for (const c of this.celulasDoMotivo) {
        const e = porEstado.get(c.estado) || { estado: c.estado, total: 0, validados: 0, validos: 0 };
        e.total += c.validados;
        e.validados += c.validados;
        e.validos += c.validos;
        porEstado.set(c.estado, e);
      }
      return Array.from(porEstado.values())
        .map((e) => ({
          ...e,
          rejeitados: Math.max(e.validados - e.validos, 0),
          pct_validos_dos_validados: e.validados ? Math.round((e.validos / e.validados) * 1000) / 10 : 0,
        }))
        .sort((a, b) => b.total - a.total);
    },
  },
  watch: {
    celulasVisiveis(celulas) {
      if (this.camadaCalor) this.camadaCalor.setCelulas(celulas);
      if (this.camadaPontos) this.camadaPontos.setCelulas(celulas);
    },
    camadas() {
      this.aplicarCamadas();
    },
    // Origem, agência, estado ou motivo mudaram: a tabela volta à primeira página.
    paramsEnderecos(novo, antigo) {
      if (JSON.stringify(novo) === JSON.stringify(antigo)) return;
      this.pageNumber = 1;
      this.serverTableLoad();
    },
  },
  created() {
    // Mapa e camadas Leaflet fora do data: não precisam (nem devem) ser reativos.
    this.mapa = null;
    this.camadaCalor = null;
    this.camadaPontos = null;
  },
  mounted() {
    this.token = sessionStorage.getItem("api");
    this.populaAgencias();
    this.populaTurnos();
    this.carregar();
    // Antes do update:options inicial da tabela, que é ignorado enquanto esta carga roda.
    this.serverTableLoad();
  },
  methods: {
    agenciaLabel(agencia) {
      if (!agencia) return '';
      const cod = agencia.cod_agencia != null ? String(agencia.cod_agencia).trim() : '';
      const nome = agencia.nome != null ? String(agencia.nome).trim() : '';
      if (cod && nome) return `${cod} - ${nome}`;
      return cod || nome;
    },
    populaAgencias() {
      apiController.request(apiController.endpoints.getallAgenciasemprego, {
        onSuccess: (response) => {
          this.agencias = Array.isArray(response.data) ? response.data : [];
        },
      });
    },
    populaTurnos() {
      apiController.request(apiController.endpoints.getallTurnos, {
        onSuccess: (response) => {
          this.turnos = Array.isArray(response.data) ? response.data : [];
        },
      });
    },
    numero(v) {
      return Number(v || 0).toLocaleString(this.$i18n && this.$i18n.locale);
    },
    pct(v) {
      return formatPct(v, this.$i18n && this.$i18n.locale);
    },
    /** Mesma frase que a validação devolve, montada da chave gravada (addressValidation.*). */
    textoMotivo(r) {
      if (!r.motivo) {
        return this.$t(r.validado
          ? 'relExternalAddressKpis.reasons.notRecordedValidated'
          : 'relExternalAddressKpis.reasons.notRecordedRejected');
      }
      const chave = `addressValidation.${r.motivo}`;
      if (r.motivo === 'addressValidatedWithAdjustments') {
        const pendencias = (r.ajustes || []).map((a) => {
          const k = AJUSTES_VALIDACAO[a] ? `addressValidation.${AJUSTES_VALIDACAO[a]}` : null;
          return k && this.$te(k) ? this.$t(k) : a;
        });
        return this.$t(chave, { adjustments: pendencias.join('; ') });
      }
      return this.$te(chave) ? this.$t(chave) : r.motivo;
    },
    corResultado(resultado) {
      if (resultado === 'V') return this.cores.valido;
      if (resultado === 'R') return this.cores.rejeitado;
      return 'grey';
    },
    /** Linha do endpoint -> linha da tabela (textos de estado, unidade e resultado). */
    mapEndereco(r) {
      const resultados = {
        V: this.$t('relExternalAddressKpis.map.validated'),
        R: this.$t('relExternalAddressKpis.map.rejected'),
        E: this.$t('relExternalAddressKpis.evaluation.withError'),
      };
      return {
        ...r,
        chave: `${r.id_agencia_emprego}|${r.id_registro}`,
        estado_texto: r.estado || this.$t('relExternalAddressKpis.map.noState'),
        melhor_linha: r.melhor_linha || '—',
        unidade: r.cod_unidade || r.descricao_unidade || '—',
        resultado_texto: resultados[r.resultado] || this.$t('relExternalAddressKpis.addresses.notEvaluated'),
      };
    },
    /** Parâmetros da página com os filtros do relatório; as colunas de texto ordenam pela original. */
    requestEnderecos(params) {
      const out = { ...params, ...this.paramsEnderecos };
      if (out.sortBy) {
        out.sortBy = String(out.sortBy).split(',').map((c) => ORDENACAO_ENDERECOS[c] || c).join(',');
      }
      return apiController.request(apiController.endpoints.getenderecoskpisEnderecosexternos, {
        data: out,
        config: { timeout: 60000 },
        silent: true,
      });
    },
    async serverTableLoad(options) {
      const seq = ++this.tabelaSeq;
      const state = {
        pageNumber: this.pageNumber,
        numberOfRows: this.numberOfRows,
        serverSortBy: this.serverSortBy,
        serverSortDesc: this.serverSortDesc,
        searchFilters: this.searchFilters,
        lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
        total: this.totalEnderecos,
      };
      const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state);
      this.loadingtable = true;
      try {
        const response = await this.requestEnderecos(params);
        if (seq !== this.tabelaSeq) return;
        const data = (response && response.data) || {};
        this.enderecos = (Array.isArray(data.items) ? data.items : []).map(this.mapEndereco);
        const updates = computePageState(
          data, { page, rowsPerPage, sortByArr, sortDescArr }, state, this.itemsPerPageLastOption
        );
        this.totalEnderecos = updates.total;
        this.pageNumber = updates.pageNumber;
        this.numberOfRows = updates.numberOfRows;
        this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
        this.serverSortBy = updates.serverSortBy;
        this.serverSortDesc = updates.serverSortDesc;
      } catch (e) {
        if (seq !== this.tabelaSeq) return;
        this.enderecos = [];
        this.totalEnderecos = 0;
        EventBus.$emit('show-error', { error: e });
      } finally {
        if (seq === this.tabelaSeq) this.loadingtable = false;
      }
    },
    loadItemsForExport(onProgress) {
      return fetchAllServerPagesForExport({
        fetchPage: async (params) => {
          const response = await this.requestEnderecos(params);
          return response && response.data;
        },
        state: {
          total: this.totalEnderecos,
          serverSortBy: this.serverSortBy,
          serverSortDesc: this.serverSortDesc,
          searchFilters: this.searchFilters,
        },
        onProgress,
        mapItems: (items) => items.map(this.mapEndereco),
      });
    },
    /**
     * Id do registro no CRUD de Candidatos: o snapshot guarda id_endereco para candidatos
     * (o `identificador` é o id da pessoa); nas outras origens, `id_registro` já é o id do CRUD.
     */
    idNoCadastro(item) {
      return this.origem === ORIGEM_CANDIDATOS ? Number(item.identificador) : Number(item.id_registro);
    },
    /** A tabela emite a seleção da página; as marcações de outras páginas ficam como estão. */
    onSelecao(marcados) {
      const chaves = new Set((marcados || []).map((e) => e.chave));
      const proxima = { ...this.selecao };
      let limiteExcedido = false;
      for (const e of this.enderecos) {
        if (!chaves.has(e.chave)) {
          delete proxima[e.chave];
          continue;
        }
        const id = this.idNoCadastro(e);
        if (!Number.isFinite(id)) continue;
        if (!(e.chave in proxima) && Object.keys(proxima).length >= LIMITE_SELECAO) {
          limiteExcedido = true;
          continue;
        }
        proxima[e.chave] = id;
      }
      if (JSON.stringify(proxima) === JSON.stringify(this.selecao)) return;
      this.selecao = proxima;
      if (limiteExcedido) {
        EventBus.$emit('show-alert', {
          tipo: 'warning',
          mensagem: this.$t('relExternalAddressKpis.selection.limitReached', { max: LIMITE_SELECAO }),
        });
      }
    },
    limparSelecao() {
      this.selecao = {};
    },
    /** Leva a seleção ao CRUD de Candidatos, na aba da origem, para revalidar. */
    irParaRevalidacao() {
      const ids = Array.from(new Set(Object.values(this.selecao)));
      if (!ids.length) return;
      salvarSelecaoRevalidacao({ origem: this.origem, ids });
      this.$router.push({ name: 'Candidatos' });
    },
    larguraBarra(parte, base) {
      return base ? `${(parte / base) * 100}%` : '0%';
    },
    /** Botão de atualizar: KPIs, mapa e a página atual da tabela. */
    atualizar() {
      this.carregar();
      this.serverTableLoad();
    },
    /** KPIs e mapa em paralelo; cada um com seu loading, como na aba. */
    carregar() {
      const seq = ++this.reqSeq;
      this.carregarKpis(seq);
      this.carregarMapa(seq);
    },
    async carregarKpis(seq) {
      this.loadingKpis = true;
      try {
        const response = await apiController.request(apiController.endpoints.getkpisEnderecosexternos, {
          data: this.params,
          config: { timeout: 30000 },
          silent: true,
        });
        if (seq !== this.reqSeq) return;
        this.kpis = response && response.data && response.data.geral ? response.data : null;
      } catch (e) {
        if (seq !== this.reqSeq) return;
        this.kpis = null;
        EventBus.$emit('show-error', { error: e });
      } finally {
        if (seq === this.reqSeq) this.loadingKpis = false;
      }
    },
    async carregarMapa(seq) {
      this.loadingMapa = true;
      try {
        const response = await apiController.request(apiController.endpoints.getmapakpisEnderecosexternos, {
          data: this.params,
          config: { timeout: 60000 },
          silent: true,
        });
        if (seq !== this.reqSeq) return;
        const data = (response && response.data) || {};
        this.estados = Array.isArray(data.estados) ? data.estados : [];
        // Mesma chave dos resultados por motivo (computed `motivos`).
        this.motivosMapa = (Array.isArray(data.motivos) ? data.motivos : []).map((m) => ({
          ...m,
          chave: `${m.motivo}|${(m.ajustes || []).join(',')}|${m.validado ? 1 : 0}`,
        }));
        // pontos: [lat, lng, total, validados, validos, índice em `estados`, índice em `motivos`].
        const pontos = Array.isArray(data.pontos) ? data.pontos : [];
        this.celulas = Object.freeze(pontos.map((p) => ({
          lat: p[0],
          lng: p[1],
          total: p[2],
          validados: p[3],
          validos: p[4],
          estado: (this.estados[p[5]] || {}).estado || '',
          motivoChave: (this.motivosMapa[p[6]] || {}).chave || null,
        })));
        if (this.estadoSelected !== null && !this.estados.some((e) => e.estado === this.estadoSelected)) {
          this.estadoSelected = null;
        }
        if (this.motivoSelected && !this.motivosMapa.some((m) => m.chave === this.motivoSelected)) {
          this.motivoSelected = null;
        }
        this.mapaCarregado = true;
        this.$nextTick(this.enquadrar);
      } catch (e) {
        if (seq !== this.reqSeq) return;
        this.celulas = [];
        this.estados = [];
        EventBus.$emit('show-error', { error: e });
      } finally {
        if (seq === this.reqSeq) this.loadingMapa = false;
      }
    },
    onMapaPronto(mapa) {
      this.mapa = mapa;
      this.mapaPronto = true;
      const opcoes = { corValido: this.cores.valido, corRejeitado: this.cores.rejeitado, corNeutra: this.cores.neutro };
      this.camadaCalor = new CamadaCalorTaxaValidacao(this.celulasVisiveis, { ...opcoes, zIndex: 2 });
      this.camadaPontos = new CamadaPontosValidacao(this.celulasVisiveis, { ...opcoes, zIndex: 3 });
      this.aplicarCamadas();
      this.enquadrar();
    },
    aplicarCamadas() {
      if (!this.mapa) return;
      const alternar = (camada, ligada) => {
        if (!camada) return;
        if (ligada && !this.mapa.hasLayer(camada)) camada.addTo(this.mapa);
        if (!ligada && this.mapa.hasLayer(camada)) this.mapa.removeLayer(camada);
      };
      alternar(this.camadaCalor, this.camadas.includes('calor'));
      alternar(this.camadaPontos, this.camadas.includes('pontos'));
    },
    zoom(delta) {
      if (this.mapa) this.mapa.setZoom(this.mapa.getZoom() + delta);
    },
    enquadrar() {
      if (!this.mapa || !this.celulasVisiveis.length) return;
      const bounds = L.latLngBounds(this.celulasVisiveis.map((c) => [c.lat, c.lng]));
      this.mapa.fitBounds(bounds, { padding: [20, 20], maxZoom: 13 });
    },
    /** Troca de origem (endereços externos, candidatos, pré-candidatos): os filtros de estado e motivo são de outro público. */
    trocarOrigem(origem) {
      if (origem == null || origem === this.origem) return;
      this.origem = origem;
      this.selecao = {};
      this.estadoSelected = null;
      this.motivoSelected = null;
      this.carregar();
    },
    /** Seleção do filtro de estado; limpar (null/undefined) volta a todos. */
    filtrarEstado(estado) {
      this.estadoSelected = estado == null ? null : (estado === SEM_ESTADO ? '' : estado);
      this.$nextTick(this.enquadrar);
    },
    /**
     * Clique num resultado filtra o mapa pelos endereços dele (no estado escolhido, se houver)
     * e rola até o mapa; clicar de novo volta a todos os motivos.
     */
    selecionarMotivo(chave) {
      this.motivoSelected = this.motivoSelected === chave ? null : chave;
      this.$nextTick(() => {
        this.enquadrar();
        const card = this.$refs.cardMapa && this.$refs.cardMapa.$el;
        if (this.motivoSelected && card && card.scrollIntoView) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    /** "Limpar" do card de filtros do mapa: volta a todos os estados e motivos. */
    limparFiltrosMapa() {
      this.estadoSelected = null;
      this.motivoSelected = null;
      this.$nextTick(this.enquadrar);
    },
    /** Clique no estado filtra o mapa e enquadra; clicar de novo volta a todos. */
    selecionarEstado(estado) {
      this.estadoSelected = this.estadoSelected === estado ? null : estado;
      this.$nextTick(this.enquadrar);
    },
    /** Resumo da célula mais próxima do clique (as camadas são canvas, sem eventos próprios). */
    onMapaClick(e) {
      if (!this.mapa || !this.camadas.length) return;
      const alvo = this.mapa.latLngToContainerPoint(e.latlng);
      let melhor = null;
      let melhorDist = RAIO_CLIQUE;
      for (const c of this.celulasVisiveis) {
        const p = this.mapa.latLngToContainerPoint([c.lat, c.lng]);
        const d = p.distanceTo(alvo);
        if (d <= melhorDist) {
          melhor = c;
          melhorDist = d;
        }
      }
      if (!melhor) return;
      const rejeitados = Math.max(melhor.validados - melhor.validos, 0);
      const conteudo = this.$t('relExternalAddressKpis.map.cellPopup', {
        state: melhor.estado || '—',
        total: this.numero(melhor.total),
        validated: this.numero(melhor.validados),
        valid: this.numero(melhor.validos),
        rejected: this.numero(rejeitados),
        pct: this.pct(melhor.validados ? (melhor.validos / melhor.validados) * 100 : 0),
      });
      const el = document.createElement('div');
      el.style.whiteSpace = 'pre-line';
      el.textContent = this.motivoSelecionado ? `${this.motivoSelecionado.texto}\n${conteudo}` : conteudo;
      L.popup().setLatLng([melhor.lat, melhor.lng]).setContent(el).openOn(this.mapa);
    },
  },
};
</script>

<style scoped>
.mapa-card {
  border-radius: 10px;
}
/* Contexto de empilhamento próprio: os panes e controles do Leaflet (z-index até 1000) ficam
   presos dentro do mapa e não passam por cima de snackbars, diálogos e menus da tela. */
.mapa-wrapper {
  position: relative;
  z-index: 0;
  isolation: isolate;
  height: 560px;
  border-radius: 8px;
  overflow: hidden;
}
.mapa-vazio {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 500;
  padding: 8px 16px;
  border-radius: 8px;
  background: var(--v-background-base, #fff);
  text-align: center;
}
.legenda-quadrado {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 2px;
}
.motivo-linha {
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
}
.motivo-linha:hover,
.motivo-linha:focus-visible,
.motivo-linha--ativa {
  background: rgba(128, 128, 128, 0.12);
  outline: none;
}
.motivo-linha--ativa {
  box-shadow: inset 3px 0 0 var(--v-primary-base, #1976d2);
}
.chip-motivo {
  max-width: 100%;
}
/* Acima dos panes e controles do Leaflet (até 1000), presos no contexto do .mapa-wrapper. */
.mapa-filtros {
  position: absolute;
  left: 12px;
  bottom: 12px;
  z-index: 1001;
  max-width: min(360px, calc(100% - 24px));
  border-radius: 8px;
}
.mapa-filtros-titulo {
  line-height: 1.4;
}
.motivo-texto {
  flex: 1 1 300px;
}
.motivo-total {
  font-family: monospace;
}
.motivo-pct {
  min-width: 44px;
  text-align: right;
  font-family: monospace;
}
.legenda-circulo {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.legenda-losango {
  display: inline-block;
  width: 9px;
  height: 9px;
  transform: rotate(45deg);
}
.legenda-gradiente {
  height: 10px;
  border-radius: 5px;
}
.estados-lista {
  max-height: 300px;
  overflow-y: auto;
}
.estado-linha {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 4px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
}
.estado-linha:hover,
.estado-linha--ativa {
  background: rgba(128, 128, 128, 0.15);
}
.estado-sigla {
  min-width: 36px;
  max-width: 110px;
  font-family: monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.estado-barra {
  flex: 1;
  display: flex;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  background: rgba(128, 128, 128, 0.2);
}
.estado-total {
  min-width: 52px;
  text-align: right;
  font-family: monospace;
}
@media (max-width: 960px) {
  .mapa-wrapper {
    height: 420px;
  }
}
</style>
